module.exports = __webpack_public_path__ + "static/img/app_img.6870313d.jpg";